export { default as Hero } from "./Hero";
export { default as Services } from "./Services";
export { default as Reviews } from "./Reviews";
export { default as Features } from "./Features";
export { default as CTAReviews } from "./CTAReviews";
export { default as AddOns } from "./AddOns";
